export type MoneyType = number;
export type BankId = string;
export type MessageId = string;
export type TransactionId = number;
export type PhoneType = string;

export interface Value<T> {
  value?: T | undefined;
  hasError: boolean;
}

export const validValue = <T>(value: T | undefined): Value<T> => ({ value, hasError: false });
